<template>
    <div id="taboola-below-article-thumbnails"></div>
</template>

<script>
export default {
    name: "TaboolaAd",
    mounted() {
        this.init();
    },
    methods: {
        init() {
            if (typeof window.__PRERENDER_INJECTED === "undefined") {
                window._taboola = window._taboola || [];
                window._taboola.push({
                    mode: "thumbs-feed-01-a",
                    container: "taboola-below-article-thumbnails",
                    placement: "Below Article Thumbnails",
                    target_type: "mix"
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#taboola-below-article-thumbnails {
    margin: 40px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/TaboolaAd/TaboolaAd.vue